var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"tooltip",staticClass:"tracking-tooltip pointer-events-none",style:({zIndex: _vm.zIndex})},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }